export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
};

export type AdditionalDeliveryField = {
  __typename?: 'AdditionalDeliveryField';
  name: Maybe<Scalars['String']['output']>;
};

export type Age = {
  __typename?: 'Age';
  a: Maybe<Scalars['Int']['output']>;
  b: Maybe<Scalars['Int']['output']>;
};

export type AuthStatus = {
  __typename?: 'AuthStatus';
  message: Maybe<Scalars['String']['output']>;
  status: Maybe<Scalars['Boolean']['output']>;
  token: Maybe<Scalars['String']['output']>;
};

export type AutoSellConfig = {
  __typename?: 'AutoSellConfig';
  organizationId: Maybe<Scalars['ID']['output']>;
  verificationMode: Maybe<AutoSellOrderVerificationMode>;
  verifyOrders: Maybe<Scalars['Boolean']['output']>;
};

export enum AutoSellOrderVerificationMode {
  All = 'All',
  None = 'None',
  WithComment = 'WithComment',
}

export type BlackFridayStatus = {
  __typename?: 'BlackFridayStatus';
  postponed: Maybe<Scalars['Boolean']['output']>;
  used: Maybe<Scalars['Boolean']['output']>;
};

export type BuyerDetails = {
  __typename?: 'BuyerDetails';
  email: Maybe<Scalars['String']['output']>;
  firstName: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  lastName: Maybe<Scalars['String']['output']>;
  phone: Maybe<Scalars['String']['output']>;
};

export type CalendarForDisplay = {
  __typename?: 'CalendarForDisplay';
  calendarForDisplayId: Maybe<Scalars['ID']['output']>;
  price: Maybe<Array<Maybe<PriceConfig>>>;
  size: Maybe<CalendarSize>;
};

export enum CalendarSize {
  S20x30 = 's20x30',
  S30x45 = 's30x45',
}

export type ConfirmDataProcessingAgreementSigningInput = {
  agreementId: Scalars['ID']['input'];
  codes: Array<InputMaybe<DataProcessingAgreementSmsCodeInput>>;
};

export type CoverSetup = {
  __typename?: 'CoverSetup';
  coverSetupId: Maybe<Scalars['ID']['output']>;
  file: Maybe<Scalars['String']['output']>;
  size: Maybe<CoverSize>;
  x: Maybe<Scalars['Float']['output']>;
  y: Maybe<Scalars['Float']['output']>;
};

export type CoverSize = {
  __typename?: 'CoverSize';
  h: Maybe<Scalars['Int']['output']>;
  w: Maybe<Scalars['Int']['output']>;
};

export type CoverSizeInput = {
  h: Scalars['Int']['input'];
  w: Scalars['Int']['input'];
};

export type CoverUpdateDetails = {
  file: Scalars['String']['input'];
  size: CoverSizeInput;
  x: Scalars['Float']['input'];
  y: Scalars['Float']['input'];
};

export enum CreditType {
  Session = 'Session',
}

export type CustomLabel = {
  __typename?: 'CustomLabel';
  language: Maybe<Scalars['String']['output']>;
  text: Maybe<Scalars['String']['output']>;
};

export type CustomLabelInput = {
  language: Scalars['String']['input'];
  text: Scalars['String']['input'];
};

export type Data = {
  id: Maybe<Scalars['String']['output']>;
};

export type DataAgreementDetails = {
  __typename?: 'DataAgreementDetails';
  companyBuildingNumber: Maybe<Scalars['String']['output']>;
  companyCity: Maybe<Scalars['String']['output']>;
  companyFlatNumber: Maybe<Scalars['String']['output']>;
  companyName: Maybe<Scalars['String']['output']>;
  companyStreet: Maybe<Scalars['String']['output']>;
  companyVatId: Maybe<Scalars['String']['output']>;
  companyZipCode: Maybe<Scalars['String']['output']>;
  pesel: Maybe<Scalars['String']['output']>;
};

export type DataAgreementDetailsInput = {
  companyBuildingNumber?: InputMaybe<Scalars['String']['input']>;
  companyCity?: InputMaybe<Scalars['String']['input']>;
  companyFlatNumber?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  companyStreet?: InputMaybe<Scalars['String']['input']>;
  companyVatId?: InputMaybe<Scalars['String']['input']>;
  companyZipCode?: InputMaybe<Scalars['String']['input']>;
  pesel?: InputMaybe<Scalars['String']['input']>;
};

export type DataProcessingAgreement = {
  __typename?: 'DataProcessingAgreement';
  agreementId: Maybe<Scalars['ID']['output']>;
  businessType: Maybe<DataProcessingAgreementBusinessType>;
  created: Maybe<Scalars['Float']['output']>;
  dataAgreementDetails: Maybe<DataAgreementDetails>;
  organizationId: Maybe<Scalars['ID']['output']>;
  representatives: Maybe<Array<Maybe<DataProcessingAgreementRepresentative>>>;
  signedAt: Maybe<Scalars['Float']['output']>;
  status: Maybe<DataProcessingAgreementStatus>;
  tosContent: Maybe<Array<Maybe<CustomLabel>>>;
  tosId: Maybe<Scalars['ID']['output']>;
  tosRevisionCreated: Maybe<Scalars['Float']['output']>;
  tosRevisionId: Maybe<Scalars['ID']['output']>;
  updated: Maybe<Scalars['Float']['output']>;
};

export enum DataProcessingAgreementBusinessType {
  Company = 'COMPANY',
  Unregistered = 'UNREGISTERED',
}

export type DataProcessingAgreementDraft = {
  __typename?: 'DataProcessingAgreementDraft';
  businessType: Maybe<DataProcessingAgreementBusinessType>;
  dataAgreementDetails: Maybe<DataAgreementDetails>;
  organizationId: Maybe<Scalars['ID']['output']>;
  representatives: Maybe<
    Array<Maybe<DataProcessingAgreementDraftRepresentative>>
  >;
};

export type DataProcessingAgreementDraftRepresentative = {
  __typename?: 'DataProcessingAgreementDraftRepresentative';
  firstName: Maybe<Scalars['String']['output']>;
  lastName: Maybe<Scalars['String']['output']>;
  pesel: Maybe<Scalars['String']['output']>;
  phone: Maybe<Scalars['String']['output']>;
};

export type DataProcessingAgreementRepresentative = {
  __typename?: 'DataProcessingAgreementRepresentative';
  firstName: Maybe<Scalars['String']['output']>;
  lastName: Maybe<Scalars['String']['output']>;
  pesel: Maybe<Scalars['String']['output']>;
  phone: Maybe<Scalars['String']['output']>;
  verified: Maybe<Scalars['Boolean']['output']>;
};

export type DataProcessingAgreementRepresentativeInput = {
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  pesel: Scalars['String']['input'];
  phone: Scalars['String']['input'];
};

export type DataProcessingAgreementSigningConfirmResult = {
  __typename?: 'DataProcessingAgreementSigningConfirmResult';
  message: Maybe<Scalars['String']['output']>;
  status: Maybe<Scalars['Boolean']['output']>;
};

export type DataProcessingAgreementSigningStartResult = {
  __typename?: 'DataProcessingAgreementSigningStartResult';
  agreementId: Maybe<Scalars['ID']['output']>;
  message: Maybe<Scalars['String']['output']>;
  status: Maybe<Scalars['Boolean']['output']>;
};

export type DataProcessingAgreementSmsCodeInput = {
  code: Scalars['String']['input'];
  phone: Scalars['String']['input'];
};

export enum DataProcessingAgreementStatus {
  Pending = 'PENDING',
  Signed = 'SIGNED',
}

export type DataProcessingAgreementTosPreview = {
  __typename?: 'DataProcessingAgreementTosPreview';
  content: Maybe<Array<Maybe<CustomLabel>>>;
  tosId: Maybe<Scalars['ID']['output']>;
  tosRevisionId: Maybe<Scalars['ID']['output']>;
};

export enum DeadlineScenario {
  Deadline = 'Deadline',
  Timeout = 'Timeout',
  Unlimited = 'Unlimited',
}

export type DecorationField = {
  __typename?: 'DecorationField';
  decorationFieldId: Maybe<Scalars['ID']['output']>;
  types: Maybe<Array<Maybe<DecorationFieldType>>>;
};

export enum DecorationFieldType {
  Connector = 'Connector',
  Date = 'Date',
  FirstName = 'FirstName',
  FirstNameInitial = 'FirstNameInitial',
  SecondName = 'SecondName',
  SecondNameInitial = 'SecondNameInitial',
}

export type DecorationForClient = {
  __typename?: 'DecorationForClient';
  decorationForClientId: Maybe<Scalars['ID']['output']>;
  fields: Maybe<Array<Maybe<DecorationField>>>;
};

export type DecorationPreConfigForClient = {
  __typename?: 'DecorationPreConfigForClient';
  connector: Maybe<Scalars['String']['output']>;
  date: Maybe<Scalars['String']['output']>;
  decorationPreConfigForClientId: Maybe<Scalars['ID']['output']>;
  firstName: Maybe<Scalars['String']['output']>;
  secondName: Maybe<Scalars['String']['output']>;
};

export type DeliveryAddress = {
  __typename?: 'DeliveryAddress';
  additional: Maybe<Scalars['String']['output']>;
  buildingNumber: Maybe<Scalars['String']['output']>;
  city: Maybe<Scalars['String']['output']>;
  deliveryAddressId: Maybe<Scalars['ID']['output']>;
  firstName: Maybe<Scalars['String']['output']>;
  flatNumber: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  lastName: Maybe<Scalars['String']['output']>;
  postCode: Maybe<Scalars['String']['output']>;
  street: Maybe<Scalars['String']['output']>;
};

export type DeliveryMethod = {
  __typename?: 'DeliveryMethod';
  additionalFields: Maybe<Array<Maybe<AdditionalDeliveryField>>>;
  addressRequired: Maybe<Scalars['Boolean']['output']>;
  context: Maybe<Array<Maybe<DeliveryMethodContext>>>;
  countryId: Maybe<Scalars['String']['output']>;
  currencyId: Maybe<Scalars['String']['output']>;
  deliveryMethodId: Maybe<Scalars['ID']['output']>;
  easyPackOrgId: Maybe<Scalars['ID']['output']>;
  easyPackToken: Maybe<Scalars['ID']['output']>;
  freeFrom: Maybe<Scalars['Float']['output']>;
  label: Maybe<Scalars['String']['output']>;
  mightBeFree: Maybe<Scalars['Boolean']['output']>;
  organizationId: Maybe<Scalars['ID']['output']>;
  phoneRequired: Maybe<Scalars['Boolean']['output']>;
  pickupAddress: Maybe<Scalars['String']['output']>;
  pickupNote: Maybe<Scalars['String']['output']>;
  preOrderNote: Maybe<Scalars['String']['output']>;
  price: Maybe<Scalars['Float']['output']>;
  status: Maybe<Scalars['Boolean']['output']>;
  type: Maybe<DeliveryType>;
};

export enum DeliveryMethodContext {
  EmbedStore = 'EmbedStore',
  Lab = 'Lab',
  PrivateSession = 'PrivateSession',
  PublicSession = 'PublicSession',
  Wedding = 'Wedding',
}

export type DeliveryMethodForDisplay = {
  __typename?: 'DeliveryMethodForDisplay';
  additionalFields: Maybe<Array<Maybe<AdditionalDeliveryField>>>;
  addressRequired: Maybe<Scalars['Boolean']['output']>;
  countryId: Maybe<Scalars['String']['output']>;
  currencyId: Maybe<Scalars['String']['output']>;
  deliveryMethodId: Maybe<Scalars['ID']['output']>;
  freeFrom: Maybe<Scalars['Float']['output']>;
  isAutoSell: Maybe<Scalars['Boolean']['output']>;
  label: Maybe<Scalars['String']['output']>;
  mightBeFree: Maybe<Scalars['Boolean']['output']>;
  phoneRequired: Maybe<Scalars['Boolean']['output']>;
  pickupAddress: Maybe<Scalars['String']['output']>;
  pickupNote: Maybe<Scalars['String']['output']>;
  preOrderNote: Maybe<Scalars['String']['output']>;
  price: Maybe<Scalars['Float']['output']>;
  status: Maybe<Scalars['Boolean']['output']>;
  type: Maybe<DeliveryType>;
};

export enum DeliveryType {
  Courier = 'Courier',
  Digital = 'Digital',
  EasyPack24 = 'EasyPack24',
  Pickup = 'Pickup',
}

export type DeviceLoggedOutEvent = {
  __typename?: 'DeviceLoggedOutEvent';
  deviceId: Scalars['ID']['output'];
  occurredAt: Scalars['Int']['output'];
};

export type FilePricing = {
  __typename?: 'FilePricing';
  filePricingId: Maybe<Scalars['String']['output']>;
  isFull: Maybe<Scalars['Boolean']['output']>;
  price: Maybe<Array<Maybe<PriceConfig>>>;
  printsIncluded: Maybe<Array<Maybe<PrintsCount>>>;
  size: Maybe<Scalars['Int']['output']>;
  stepPricing: Maybe<StepPricing>;
  stepPricingEnabled: Maybe<Scalars['Boolean']['output']>;
};

export type FilePricingInput = {
  filePricingId: Scalars['String']['input'];
  isFull: Scalars['Boolean']['input'];
  price: Array<InputMaybe<PriceConfigInput>>;
  printsIncluded: Array<InputMaybe<UpdatePrintsCount>>;
  size: Scalars['Int']['input'];
  stepPricing: StepPricingInput;
  stepPricingEnabled: Scalars['Boolean']['input'];
};

export type FileWatermark = {
  __typename?: 'FileWatermark';
  fileName: Maybe<Scalars['ID']['output']>;
  fileWatermarkId: Maybe<Scalars['ID']['output']>;
  height: Maybe<Scalars['Int']['output']>;
  name: Maybe<Scalars['String']['output']>;
  organizationId: Maybe<Scalars['ID']['output']>;
  status: Maybe<Scalars['Int']['output']>;
  type: Maybe<Scalars['Int']['output']>;
  width: Maybe<Scalars['Int']['output']>;
};

export type FileWatermarkInput = {
  fileName: Scalars['ID']['input'];
  height?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  status?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['Int']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

export enum FilesAndPrintsPackageType {
  AnyImage = 'AnyImage',
  OneImage = 'OneImage',
  PickedImage = 'PickedImage',
}

export type FilesConfig = {
  __typename?: 'FilesConfig';
  count: Maybe<Scalars['Int']['output']>;
  isFull: Maybe<Scalars['Boolean']['output']>;
  size: Maybe<Scalars['Int']['output']>;
};

export type ForcedImageConfig = {
  __typename?: 'ForcedImageConfig';
  photoGroupId: Maybe<Scalars['ID']['output']>;
  photoId: Maybe<Scalars['ID']['output']>;
};

export type ForcedImageConfigUpdate = {
  photoGroupId?: InputMaybe<Scalars['ID']['input']>;
  photoId?: InputMaybe<Scalars['ID']['input']>;
};

export type FramesOrder = {
  __typename?: 'FramesOrder';
  hash: Maybe<Scalars['String']['output']>;
  orderNumber: Maybe<Scalars['Int']['output']>;
  status: Maybe<Scalars['Boolean']['output']>;
};

export type FramesOrderInput = {
  black?: InputMaybe<Scalars['Int']['input']>;
  clientEmail?: InputMaybe<Scalars['String']['input']>;
  clientFirstName?: InputMaybe<Scalars['String']['input']>;
  clientLastName?: InputMaybe<Scalars['String']['input']>;
  clientPhone?: InputMaybe<Scalars['String']['input']>;
  companyBuildingNumber?: InputMaybe<Scalars['String']['input']>;
  companyCity?: InputMaybe<Scalars['String']['input']>;
  companyFlatNumber?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  companyStreet?: InputMaybe<Scalars['String']['input']>;
  companyVatId?: InputMaybe<Scalars['String']['input']>;
  companyZipCode?: InputMaybe<Scalars['String']['input']>;
  deliveryAddressSameAsCompany?: InputMaybe<Scalars['Boolean']['input']>;
  deliveryBuildingNumber?: InputMaybe<Scalars['String']['input']>;
  deliveryCity?: InputMaybe<Scalars['String']['input']>;
  deliveryFlatNumber?: InputMaybe<Scalars['String']['input']>;
  deliveryStreet?: InputMaybe<Scalars['String']['input']>;
  deliveryType?: InputMaybe<Scalars['String']['input']>;
  deliveryZipCode?: InputMaybe<Scalars['String']['input']>;
  lockerAddress?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lockerId?: InputMaybe<Scalars['String']['input']>;
  white?: InputMaybe<Scalars['Int']['input']>;
};

export enum GroupImagesByPeopleTypeForDisplay {
  FirstName = 'FirstName',
  FullName = 'FullName',
}

export type ImageForDisplay = {
  __typename?: 'ImageForDisplay';
  height: Maybe<Scalars['Int']['output']>;
  originalName: Maybe<Scalars['String']['output']>;
  photoGroupHasPhotoId: Scalars['String']['output'];
  photoGroupId: Maybe<Scalars['String']['output']>;
  photoId: Maybe<Scalars['String']['output']>;
  width: Maybe<Scalars['Int']['output']>;
};

export type InvoiceCompany = {
  __typename?: 'InvoiceCompany';
  address: Maybe<Scalars['String']['output']>;
  city: Maybe<Scalars['String']['output']>;
  country: Maybe<Scalars['String']['output']>;
  logo: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  postCode: Maybe<Scalars['String']['output']>;
  vatId: Maybe<Scalars['String']['output']>;
};

export type InvoiceDetails = {
  __typename?: 'InvoiceDetails';
  buyerEmail: Maybe<Scalars['String']['output']>;
  companyAddress: Maybe<Scalars['String']['output']>;
  companyCity: Maybe<Scalars['String']['output']>;
  companyName: Maybe<Scalars['String']['output']>;
  companyPostCode: Maybe<Scalars['String']['output']>;
  companyVatId: Maybe<Scalars['String']['output']>;
  invoiceItems: Maybe<Array<Maybe<InvoiceToBeCreatedInvoiceItem>>>;
};

export enum InvoiceToBeCreatedContext {
  DigitalTemplateOrder = 'DigitalTemplateOrder',
  DigitalTemplateRent = 'DigitalTemplateRent',
  PhotographerOrder = 'PhotographerOrder',
  PublicSessionSignupPrepayment = 'PublicSessionSignupPrepayment',
  SupplierOrder = 'SupplierOrder',
  ZalamoCredits = 'ZalamoCredits',
  ZalamoPayCommission = 'ZalamoPayCommission',
}

export type InvoiceToBeCreatedInvoiceItem = {
  __typename?: 'InvoiceToBeCreatedInvoiceItem';
  amount: Scalars['Float']['output'];
  count: Scalars['Int']['output'];
  label: Maybe<Scalars['String']['output']>;
  pricePerItem: Scalars['Float']['output'];
  type: Maybe<InvoiceToBeCreatedItemType>;
  vatExemptionLegalBasis: Maybe<Scalars['String']['output']>;
  vatRate: Scalars['Int']['output'];
  vatType: Maybe<VatType>;
};

export enum InvoiceToBeCreatedItemType {
  Delivery = 'Delivery',
  Digital = 'Digital',
  MarketingServices = 'MarketingServices',
  PhotographyService = 'PhotographyService',
  Prints = 'Prints',
  Product = 'Product',
  ZalamoPayCommission = 'ZalamoPayCommission',
}

export type KeywordsList = {
  __typename?: 'KeywordsList';
  keywordsListId: Maybe<Scalars['ID']['output']>;
  list: Maybe<Array<Maybe<PhotoKeywords>>>;
};

export enum KsefAuthSubjectIdentifierType {
  CertificateFingerprint = 'certificateFingerprint',
  CertificateSubject = 'certificateSubject',
}

export enum KsefCertificateType {
  Auth = 'auth',
  Offline = 'offline',
}

export type KsefConnectionTestResult = {
  __typename?: 'KsefConnectionTestResult';
  message: Maybe<Scalars['String']['output']>;
  success: Maybe<Scalars['Boolean']['output']>;
};

export enum KsefEligibilityReason {
  ConfigDisabled = 'ConfigDisabled',
  Eligible = 'Eligible',
  MissingConfig = 'MissingConfig',
  MissingSellerData = 'MissingSellerData',
  NotApplicableBeforeCutoff = 'NotApplicableBeforeCutoff',
  NotEvaluated = 'NotEvaluated',
  NotPolishSeller = 'NotPolishSeller',
}

export enum KsefEnvironment {
  Demo = 'demo',
  Prod = 'prod',
  Test = 'test',
}

export enum KsefMode {
  Awaria = 'awaria',
  Offline = 'offline',
  Offline24 = 'offline24',
  Online = 'online',
}

export enum KsefStatus {
  Accepted = 'Accepted',
  ManualActionRequired = 'ManualActionRequired',
  NotApplicable = 'NotApplicable',
  NotApplicableBeforeCutoff = 'NotApplicableBeforeCutoff',
  NotEvaluated = 'NotEvaluated',
  Publishing = 'Publishing',
  Queued = 'Queued',
  Rejected = 'Rejected',
  RetryScheduled = 'RetryScheduled',
  SubmittedOffline = 'SubmittedOffline',
  SubmittedOnline = 'SubmittedOnline',
}

export type ListOfGroupsInSessionDisplay = {
  __typename?: 'ListOfGroupsInSessionDisplay';
  groups: Maybe<Array<Maybe<PublicSessionGroupForDisplay>>>;
  id: Maybe<Scalars['ID']['output']>;
  watermarkCacheBomb: Maybe<Scalars['String']['output']>;
};

export type LookBookDetailsForClient = {
  __typename?: 'LookBookDetailsForClient';
  configs: Maybe<Array<Maybe<LookBookProductConfig>>>;
  decorationPreConfig: Maybe<DecorationPreConfigForClient>;
  labs: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  lookBookId: Maybe<Scalars['ID']['output']>;
  occasion: Maybe<LookBookOccasionForClient>;
  postOrderMessage: Maybe<Array<Maybe<CustomLabel>>>;
  spreadsCount: Maybe<Scalars['Int']['output']>;
  welcomeMessage: Maybe<Array<Maybe<CustomLabel>>>;
};

export type LookBookInBasketInput = {
  config?: InputMaybe<Scalars['String']['input']>;
  countPhotos?: InputMaybe<LookBookProductImageLimitationInput>;
  finished?: InputMaybe<Scalars['Boolean']['input']>;
  firstAddedFile?: InputMaybe<Scalars['Boolean']['input']>;
  hasPersonalization?: InputMaybe<Scalars['Boolean']['input']>;
  imageMap?: InputMaybe<Array<InputMaybe<WallDecorRenderPieceConfigInput>>>;
  lookBookProductConfigId?: InputMaybe<Scalars['ID']['input']>;
  lookBookProductId?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Array<InputMaybe<CustomLabelInput>>>;
  nameClientProduct?: InputMaybe<Scalars['String']['input']>;
  personalizationConfig?: InputMaybe<Scalars['String']['input']>;
  photoIdList?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  price?: InputMaybe<Array<InputMaybe<PriceConfigInput>>>;
  productsInPlay?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  redBackground?: InputMaybe<Scalars['Boolean']['input']>;
  thumb?: InputMaybe<Scalars['String']['input']>;
  valueMap?: InputMaybe<Scalars['String']['input']>;
};

export enum LookBookOccasionForClient {
  ChildSession = 'ChildSession',
  CoupleAnniversary = 'CoupleAnniversary',
  FamilyEvent = 'FamilyEvent',
  FirstCommunion = 'FirstCommunion',
  OtherOccasion = 'OtherOccasion',
  Wedding = 'Wedding',
}

export enum LookBookPriceRounding {
  Five = 'Five',
  One = 'One',
  Ten = 'Ten',
}

export type LookBookProductConfig = {
  __typename?: 'LookBookProductConfig';
  config: Maybe<Scalars['String']['output']>;
  cost: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  count: Maybe<Scalars['Int']['output']>;
  created: Maybe<Scalars['Int']['output']>;
  deleted: Maybe<Scalars['Boolean']['output']>;
  hasPersonalization: Maybe<Scalars['Boolean']['output']>;
  label: Maybe<Scalars['String']['output']>;
  lookBookProductConfigId: Maybe<Scalars['ID']['output']>;
  personalizationConfig: Maybe<Scalars['String']['output']>;
  sent: Maybe<Scalars['Boolean']['output']>;
  sentWhen: Maybe<Scalars['Int']['output']>;
  thumb: Maybe<Scalars['String']['output']>;
};

export type LookBookProductConfigUpdate = {
  config?: InputMaybe<Scalars['String']['input']>;
  count?: InputMaybe<Scalars['Int']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  thumb?: InputMaybe<Scalars['String']['input']>;
};

export type LookBookProductImageLimitation = {
  __typename?: 'LookBookProductImageLimitation';
  max: Maybe<Scalars['Int']['output']>;
  min: Maybe<Scalars['Int']['output']>;
};

export type LookBookProductImageLimitationInput = {
  max?: InputMaybe<Scalars['Int']['input']>;
  min?: InputMaybe<Scalars['Int']['input']>;
};

export type LookBookProductInBasket = {
  __typename?: 'LookBookProductInBasket';
  accessToken: Maybe<Scalars['String']['output']>;
  config: Maybe<Scalars['String']['output']>;
  countPhotos: Maybe<LookBookProductImageLimitation>;
  finished: Maybe<Scalars['Boolean']['output']>;
  firstAddedFile: Maybe<Scalars['Boolean']['output']>;
  hasPersonalization: Maybe<Scalars['Boolean']['output']>;
  imageMap: Maybe<Array<Maybe<WallDecorRenderPieceConfig>>>;
  lookBookProductConfigId: Maybe<Scalars['ID']['output']>;
  lookBookProductId: Maybe<Scalars['ID']['output']>;
  name: Maybe<Array<Maybe<CustomLabel>>>;
  nameClientProduct: Maybe<Scalars['String']['output']>;
  personalizationConfig: Maybe<Scalars['String']['output']>;
  photoIdList: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  price: Maybe<Array<Maybe<PriceConfig>>>;
  productsInPlay: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  quantity: Maybe<Scalars['Int']['output']>;
  redBackground: Maybe<Scalars['Boolean']['output']>;
  thumb: Maybe<Scalars['String']['output']>;
  timeAddedToShoppingCart: Maybe<Scalars['Int']['output']>;
  valueMap: Maybe<Scalars['String']['output']>;
};

export type MagnetForDisplay = {
  __typename?: 'MagnetForDisplay';
  magnetForDisplayId: Maybe<Scalars['ID']['output']>;
  price: Maybe<Array<Maybe<PriceConfig>>>;
  size: Maybe<MagnetSize>;
};

export enum MagnetSize {
  S6_67x10 = 's6_67x10',
  S10x15 = 's10x15',
}

export type Mutation = {
  __typename?: 'Mutation';
  confirmDataProcessingAgreementSigning: Maybe<DataProcessingAgreementSigningConfirmResult>;
  createPhotographerMobileNotificationsPairingToken: PhotographerMobileNotificationsPairingToken;
  createZalamoPayAccount: Maybe<ZalamoPayRegisterResponse>;
  importOrganizationKsefCertificate: Maybe<OrganizationKsefConfig>;
  insertFileWatermark: Maybe<FileWatermark>;
  insertSoldFileWatermark: Maybe<SoldFilesWatermarkConfig>;
  insertZalamoPayInvoiceItem: Maybe<ZalamoPayInvoiceItem>;
  placeZalamoFramesOrder: Maybe<FramesOrder>;
  placeZalamoSamplePrintOrder: Maybe<SampleSupplierOrderConfig>;
  placeZalamoSampleSupplierOrder: Maybe<SampleSupplierOrderConfig>;
  publishOrganizationInvoiceToKsef: Maybe<OrganizationInvoiceSummary>;
  retryOrganizationInvoiceKsefPublication: Maybe<OrganizationInvoiceSummary>;
  saveDataProcessingAgreementDraft: Maybe<DataProcessingAgreementDraft>;
  setOrganizationInvoiceKsefMode: Maybe<OrganizationInvoiceSummary>;
  setOrganizationKsefMode: Maybe<OrganizationKsefConfig>;
  setSubdomain: Maybe<SubdomainUpdateResult>;
  startDataProcessingAgreementSigning: Maybe<DataProcessingAgreementSigningStartResult>;
  testOrganizationKsefConnection: Maybe<KsefConnectionTestResult>;
  updateFileWatermark: Maybe<FileWatermark>;
  updateInvoiceDetails: Maybe<OrganizationInvoiceDetails>;
  updateMock: Maybe<Scalars['Int']['output']>;
  updateSoldWatermark: Maybe<SoldFilesWatermarkConfig>;
  updateSuppliersSamplesConfig: Maybe<SupplierOrdersConfig>;
  upsertOrganizationKsefConfig: Maybe<OrganizationKsefConfig>;
};

export type MutationConfirmDataProcessingAgreementSigningArgs = {
  input: ConfirmDataProcessingAgreementSigningInput;
  organizationId: Scalars['ID']['input'];
};

export type MutationCreatePhotographerMobileNotificationsPairingTokenArgs = {
  organizationId: Scalars['ID']['input'];
};

export type MutationCreateZalamoPayAccountArgs = {
  input: ZalamoPayP24RegisterInput;
  organizationId: Scalars['ID']['input'];
};

export type MutationImportOrganizationKsefCertificateArgs = {
  certificate: OrganizationKsefCertificateInput;
  environment: KsefEnvironment;
  organizationId: Scalars['ID']['input'];
  type: KsefCertificateType;
};

export type MutationInsertFileWatermarkArgs = {
  fileWatermarkId: Scalars['ID']['input'];
  input?: InputMaybe<FileWatermarkInput>;
};

export type MutationInsertSoldFileWatermarkArgs = {
  input?: InputMaybe<SoldFilesWatermarkConfigInput>;
  photoId?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationInsertZalamoPayInvoiceItemArgs = {
  amount: Scalars['Float']['input'];
  context?: InputMaybe<Scalars['String']['input']>;
  contextId?: InputMaybe<Scalars['ID']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  reason: ZalamoPayTransferReason;
};

export type MutationPlaceZalamoFramesOrderArgs = {
  input: FramesOrderInput;
};

export type MutationPlaceZalamoSamplePrintOrderArgs = {
  deliveryDetails: SamplesSupplierOrderInput;
  prints: Array<InputMaybe<Scalars['ID']['input']>>;
  supplierId: Scalars['ID']['input'];
};

export type MutationPlaceZalamoSampleSupplierOrderArgs = {
  input: SamplesSupplierOrderInput;
};

export type MutationPublishOrganizationInvoiceToKsefArgs = {
  organizationInvoiceId: Scalars['ID']['input'];
  sandbox: Scalars['Boolean']['input'];
};

export type MutationRetryOrganizationInvoiceKsefPublicationArgs = {
  organizationInvoiceId: Scalars['ID']['input'];
};

export type MutationSaveDataProcessingAgreementDraftArgs = {
  input: SaveDataProcessingAgreementDraftInput;
  organizationId: Scalars['ID']['input'];
};

export type MutationSetOrganizationInvoiceKsefModeArgs = {
  mode: KsefMode;
  organizationInvoiceId: Scalars['ID']['input'];
};

export type MutationSetOrganizationKsefModeArgs = {
  environment?: InputMaybe<KsefEnvironment>;
  mode: KsefMode;
  organizationId: Scalars['ID']['input'];
};

export type MutationSetSubdomainArgs = {
  organizationId: Scalars['ID']['input'];
  subdomain: Scalars['String']['input'];
};

export type MutationStartDataProcessingAgreementSigningArgs = {
  input: StartDataProcessingAgreementSigningInput;
  organizationId: Scalars['ID']['input'];
};

export type MutationTestOrganizationKsefConnectionArgs = {
  environment?: InputMaybe<KsefEnvironment>;
  organizationId: Scalars['ID']['input'];
};

export type MutationUpdateFileWatermarkArgs = {
  fileWatermarkId: Scalars['ID']['input'];
  update: FileWatermarkInput;
};

export type MutationUpdateInvoiceDetailsArgs = {
  organizationId: Scalars['ID']['input'];
  update: OrganizationInvoiceDetailsUpdate;
};

export type MutationUpdateSoldWatermarkArgs = {
  soldWatermarkDetailId: Scalars['ID']['input'];
  update?: InputMaybe<SoldFilesWatermarkConfigInput>;
};

export type MutationUpdateSuppliersSamplesConfigArgs = {
  input: SampleSupplierOrderInput;
  organizationId: Scalars['ID']['input'];
};

export type MutationUpsertOrganizationKsefConfigArgs = {
  input: OrganizationKsefConfigInput;
};

export type MutationResponse = {
  __typename?: 'MutationResponse';
  status: Maybe<Scalars['Boolean']['output']>;
};

export type MutationStatus = {
  __typename?: 'MutationStatus';
  status: Maybe<Scalars['Boolean']['output']>;
};

export enum NiceUrlContainer {
  PublicSession = 'PublicSession',
}

export type NiceUrlValidationStatus = {
  __typename?: 'NiceUrlValidationStatus';
  status: Maybe<Scalars['Boolean']['output']>;
};

export type NumberRange = {
  __typename?: 'NumberRange';
  max: Maybe<Scalars['Int']['output']>;
  min: Maybe<Scalars['Int']['output']>;
};

export type Organization = {
  __typename?: 'Organization';
  subdomain: Maybe<Scalars['String']['output']>;
};

export type OrganizationInvoiceDetails = {
  __typename?: 'OrganizationInvoiceDetails';
  address: Maybe<Scalars['String']['output']>;
  city: Maybe<Scalars['String']['output']>;
  companyName: Maybe<Scalars['String']['output']>;
  country: Maybe<Scalars['String']['output']>;
  organizationInvoiceDetailsId: Maybe<Scalars['ID']['output']>;
  postCode: Maybe<Scalars['String']['output']>;
  vatNumber: Maybe<Scalars['String']['output']>;
};

export type OrganizationInvoiceDetailsUpdate = {
  address: Scalars['String']['input'];
  city: Scalars['String']['input'];
  companyName: Scalars['String']['input'];
  country: Scalars['String']['input'];
  postCode: Scalars['String']['input'];
  vatNumber: Scalars['String']['input'];
};

export type OrganizationInvoiceItem = {
  __typename?: 'OrganizationInvoiceItem';
  count: Maybe<Scalars['Int']['output']>;
  price: Maybe<Scalars['Float']['output']>;
  title: Maybe<Scalars['String']['output']>;
  total: Maybe<Scalars['Float']['output']>;
  type: Maybe<InvoiceToBeCreatedItemType>;
  vat: Maybe<Scalars['Int']['output']>;
  vatExemptionLegalBasis: Maybe<Scalars['String']['output']>;
  vatType: Maybe<VatType>;
};

export type OrganizationInvoiceKsef = {
  __typename?: 'OrganizationInvoiceKsef';
  attemptCount: Maybe<Scalars['Int']['output']>;
  eligibilityReason: Maybe<KsefEligibilityReason>;
  environment: Maybe<KsefEnvironment>;
  ksefNumber: Maybe<Scalars['String']['output']>;
  lastAttemptAt: Maybe<Scalars['Float']['output']>;
  lastErrorCode: Maybe<Scalars['String']['output']>;
  lastErrorMessage: Maybe<Scalars['String']['output']>;
  manualActionRequired: Maybe<Scalars['Boolean']['output']>;
  mode: Maybe<KsefMode>;
  nextAttemptAt: Maybe<Scalars['Float']['output']>;
  payloadHash: Maybe<Scalars['String']['output']>;
  qrPayload: Maybe<Scalars['String']['output']>;
  sessionReferenceNumber: Maybe<Scalars['String']['output']>;
  status: Maybe<KsefStatus>;
  submissionReferenceNumber: Maybe<Scalars['String']['output']>;
  upoArtifactId: Maybe<Scalars['String']['output']>;
};

export type OrganizationInvoiceSource = {
  __typename?: 'OrganizationInvoiceSource';
  orderNumber: Maybe<Scalars['Int']['output']>;
  parts: Maybe<Array<Maybe<InvoiceToBeCreatedInvoiceItem>>>;
};

export type OrganizationInvoiceSummary = {
  __typename?: 'OrganizationInvoiceSummary';
  accountNumber: Maybe<Scalars['String']['output']>;
  buyer: Maybe<InvoiceCompany>;
  context: Maybe<Scalars['String']['output']>;
  contextId: Maybe<Scalars['String']['output']>;
  created: Maybe<Scalars['Float']['output']>;
  currencyId: Maybe<Scalars['String']['output']>;
  deadline: Maybe<Scalars['Float']['output']>;
  invoiceSources: Maybe<Array<Maybe<OrganizationInvoiceSource>>>;
  items: Maybe<Array<Maybe<OrganizationInvoiceItem>>>;
  ksef: Maybe<OrganizationInvoiceKsef>;
  locale: Maybe<Scalars['String']['output']>;
  month: Maybe<Scalars['Int']['output']>;
  number: Maybe<Scalars['String']['output']>;
  orderDate: Maybe<Scalars['Float']['output']>;
  orderNumber: Maybe<Scalars['Int']['output']>;
  organizationInvoiceId: Maybe<Scalars['ID']['output']>;
  ownerOrganizationId: Maybe<Scalars['ID']['output']>;
  receiverOrganizationId: Maybe<Scalars['ID']['output']>;
  seller: Maybe<InvoiceCompany>;
  total: Maybe<Scalars['Float']['output']>;
  year: Maybe<Scalars['Int']['output']>;
};

export type OrganizationKsefCertificate = {
  __typename?: 'OrganizationKsefCertificate';
  fingerprint: Maybe<Scalars['String']['output']>;
  hasCertificatePem: Maybe<Scalars['Boolean']['output']>;
  hasPfxBase64: Maybe<Scalars['Boolean']['output']>;
  hasPrivateKey: Maybe<Scalars['Boolean']['output']>;
  subject: Maybe<Scalars['String']['output']>;
  subjectIdentifierType: Maybe<KsefAuthSubjectIdentifierType>;
  validFrom: Maybe<Scalars['Float']['output']>;
  validTo: Maybe<Scalars['Float']['output']>;
};

export type OrganizationKsefCertificateInput = {
  certificatePem?: InputMaybe<Scalars['String']['input']>;
  fingerprint?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  pfxBase64?: InputMaybe<Scalars['String']['input']>;
  privateKeyPem?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  subjectIdentifierType?: InputMaybe<KsefAuthSubjectIdentifierType>;
  validFrom?: InputMaybe<Scalars['Float']['input']>;
  validTo?: InputMaybe<Scalars['Float']['input']>;
};

export type OrganizationKsefConfig = {
  __typename?: 'OrganizationKsefConfig';
  allowOfflineFallback: Maybe<Scalars['Boolean']['output']>;
  authCertificate: Maybe<OrganizationKsefCertificate>;
  autoPublish: Maybe<Scalars['Boolean']['output']>;
  createdAt: Maybe<Scalars['Float']['output']>;
  defaultMode: Maybe<KsefMode>;
  enabled: Maybe<Scalars['Boolean']['output']>;
  environment: Maybe<KsefEnvironment>;
  lastTestAt: Maybe<Scalars['Float']['output']>;
  lastTestError: Maybe<Scalars['String']['output']>;
  offlineCertificate: Maybe<OrganizationKsefCertificate>;
  organizationId: Maybe<Scalars['ID']['output']>;
  tokenCache: Maybe<OrganizationKsefTokenCache>;
  updatedAt: Maybe<Scalars['Float']['output']>;
};

export type OrganizationKsefConfigInput = {
  allowOfflineFallback?: InputMaybe<Scalars['Boolean']['input']>;
  autoPublish?: InputMaybe<Scalars['Boolean']['input']>;
  defaultMode?: InputMaybe<KsefMode>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  environment?: InputMaybe<KsefEnvironment>;
  organizationId: Scalars['ID']['input'];
};

export type OrganizationKsefTokenCache = {
  __typename?: 'OrganizationKsefTokenCache';
  accessTokenExpiresAt: Maybe<Scalars['Float']['output']>;
  refreshTokenExpiresAt: Maybe<Scalars['Float']['output']>;
};

export type PersonForPublicSession = {
  __typename?: 'PersonForPublicSession';
  id: Maybe<Scalars['ID']['output']>;
  label: Maybe<Scalars['String']['output']>;
};

export type Photo = {
  __typename?: 'Photo';
  fileName: Maybe<Scalars['String']['output']>;
  originalName: Maybe<Scalars['String']['output']>;
  photoId: Maybe<Scalars['String']['output']>;
};

export type PhotoKeywords = {
  __typename?: 'PhotoKeywords';
  keywords: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  photoId: Maybe<Scalars['String']['output']>;
};

export type PhotoWithPeople = {
  __typename?: 'PhotoWithPeople';
  people: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  photoId: Maybe<Scalars['ID']['output']>;
};

export type PhotographerAccount = {
  __typename?: 'PhotographerAccount';
  invoiceDetails: Maybe<OrganizationInvoiceDetails>;
  organization: Maybe<Organization>;
  photographerId: Maybe<Scalars['ID']['output']>;
  timeZone: Maybe<Scalars['ID']['output']>;
};

export type PhotographerAccountDetails = {
  __typename?: 'PhotographerAccountDetails';
  companyAddress: Maybe<Scalars['String']['output']>;
  companyCity: Maybe<Scalars['String']['output']>;
  companyName: Maybe<Scalars['String']['output']>;
  companyVatId: Maybe<Scalars['String']['output']>;
  companyZipCode: Maybe<Scalars['String']['output']>;
  email: Maybe<Scalars['String']['output']>;
  firstName: Maybe<Scalars['String']['output']>;
  lastName: Maybe<Scalars['String']['output']>;
  phone: Maybe<Scalars['String']['output']>;
  privateAddress: Maybe<Scalars['String']['output']>;
  privateCity: Maybe<Scalars['String']['output']>;
  privateCountry: Maybe<Scalars['String']['output']>;
  privateZipCode: Maybe<Scalars['String']['output']>;
};

export type PhotographerAccountDevice = {
  __typename?: 'PhotographerAccountDevice';
  deviceId: Scalars['ID']['output'];
  label: Maybe<Scalars['String']['output']>;
  lastSeen: Maybe<Scalars['Int']['output']>;
};

export type PhotographerMobileNotificationsPairingToken = {
  __typename?: 'PhotographerMobileNotificationsPairingToken';
  expiresAt: Scalars['Int']['output'];
  token: Scalars['ID']['output'];
};

export type PriceConfig = {
  __typename?: 'PriceConfig';
  code: Maybe<Scalars['String']['output']>;
  price: Maybe<Scalars['Float']['output']>;
};

export type PriceConfigInput = {
  code: Scalars['String']['input'];
  country?: InputMaybe<Scalars['String']['input']>;
  price: Scalars['Float']['input'];
};

export type PriceListInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  list?: InputMaybe<Array<InputMaybe<PriceConfigInput>>>;
};

export type PriceStep = {
  __typename?: 'PriceStep';
  price: Maybe<Array<Maybe<PriceConfig>>>;
  step: Maybe<Scalars['Int']['output']>;
};

export type PriceStepInput = {
  price: Array<InputMaybe<PriceConfigInput>>;
  step: Scalars['Int']['input'];
};

export type PrintAndFileConfig = {
  __typename?: 'PrintAndFileConfig';
  filesConfig: Maybe<Array<Maybe<FilesConfig>>>;
  forcedImage: Maybe<ForcedImageConfig>;
  groups: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  mode: Maybe<FilesAndPrintsPackageType>;
  printAndFileConfigId: Maybe<Scalars['ID']['output']>;
  printsCount: Maybe<Array<Maybe<PrintsCount>>>;
};

export type PrintFormat = {
  __typename?: 'PrintFormat';
  label: Maybe<Scalars['String']['output']>;
  printFormatId: Maybe<Scalars['ID']['output']>;
};

export type PrintFrameInBasket = {
  __typename?: 'PrintFrameInBasket';
  count: Maybe<Scalars['Int']['output']>;
  photoId: Maybe<Scalars['ID']['output']>;
  price: Maybe<Array<Maybe<PriceConfig>>>;
  printFormatId: Maybe<Scalars['ID']['output']>;
  printFrameId: Maybe<Scalars['ID']['output']>;
  ratio: Maybe<Scalars['Float']['output']>;
  value: Maybe<Scalars['String']['output']>;
};

export type PrintFrameInBasketInput = {
  count?: InputMaybe<Scalars['Int']['input']>;
  photoId?: InputMaybe<Scalars['ID']['input']>;
  price?: InputMaybe<Array<InputMaybe<PriceConfigInput>>>;
  printFormatId?: InputMaybe<Scalars['ID']['input']>;
  printFrameId?: InputMaybe<Scalars['ID']['input']>;
  ratio?: InputMaybe<Scalars['Float']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PrintPaper = {
  __typename?: 'PrintPaper';
  label: Maybe<Scalars['String']['output']>;
  printPaperId: Maybe<Scalars['ID']['output']>;
};

export type PrintPriceConfig = {
  __typename?: 'PrintPriceConfig';
  price: Maybe<Array<Maybe<PriceConfig>>>;
  printFormatId: Maybe<Scalars['ID']['output']>;
  printPaperId: Maybe<Scalars['ID']['output']>;
  stepPricing: Maybe<StepPricing>;
  stepPricingEnabled: Maybe<Scalars['Boolean']['output']>;
};

export type PrintsConfig = {
  __typename?: 'PrintsConfig';
  formats: Maybe<Array<Maybe<PrintFormat>>>;
  papers: Maybe<Array<Maybe<PrintPaper>>>;
};

export type PrintsCount = {
  __typename?: 'PrintsCount';
  count: Maybe<Scalars['Int']['output']>;
  printFormatId: Maybe<Scalars['String']['output']>;
  printPaperId: Maybe<Scalars['String']['output']>;
};

export enum PrintsPricingContext {
  PrivateSession = 'PrivateSession',
  PublicSession = 'PublicSession',
  PublicSessionGroup = 'PublicSessionGroup',
  WeddingCouple = 'WeddingCouple',
  WeddingGallery = 'WeddingGallery',
}

export type PrintsPricingList = {
  __typename?: 'PrintsPricingList';
  context: Maybe<PrintsPricingContext>;
  label: Maybe<Scalars['String']['output']>;
  prices: Maybe<Array<Maybe<PrintPriceConfig>>>;
  printsPricingListId: Maybe<Scalars['ID']['output']>;
  status: Maybe<Scalars['Boolean']['output']>;
};

export type PrintsPricingListForDisplay = {
  __typename?: 'PrintsPricingListForDisplay';
  list: Maybe<Array<Maybe<PrintPriceConfig>>>;
  printsPricingListForDisplayId: Maybe<Scalars['ID']['output']>;
};

export type Product = {
  __typename?: 'Product';
  availableOnOccasion: Maybe<Array<Maybe<SessionOccasion>>>;
  composedImages: Maybe<Scalars['String']['output']>;
  config: Maybe<Scalars['String']['output']>;
  configurationImages: Maybe<Scalars['String']['output']>;
  deliveryTime: Maybe<Scalars['Int']['output']>;
  description: Maybe<Array<Maybe<CustomLabel>>>;
  hasTaxConfig: Maybe<Scalars['Boolean']['output']>;
  hasWizard: Maybe<Scalars['Boolean']['output']>;
  imagesRequired: Maybe<Scalars['Boolean']['output']>;
  name: Maybe<Scalars['String']['output']>;
  organizationId: Maybe<Scalars['ID']['output']>;
  price: Maybe<Array<Maybe<PriceConfig>>>;
  productId: Maybe<Scalars['ID']['output']>;
  requiredImages: Maybe<NumberRange>;
  showDeliveryTime: Maybe<Scalars['Boolean']['output']>;
  sortOrder: Maybe<Scalars['Int']['output']>;
  status: Maybe<Scalars['Boolean']['output']>;
  tags: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  taxConfig: Maybe<ProductTaxConfig>;
  type: Maybe<ProductType>;
};

export type ProductConfig = {
  __typename?: 'ProductConfig';
  config: Maybe<Scalars['String']['output']>;
  customName: Maybe<Array<Maybe<CustomLabel>>>;
  icon: Maybe<Scalars['String']['output']>;
  mode: Maybe<ProductMode>;
  productId: Maybe<Scalars['String']['output']>;
  productInPackageId: Maybe<Scalars['String']['output']>;
  qty: Maybe<Scalars['Int']['output']>;
};

export type ProductForDisplay = {
  __typename?: 'ProductForDisplay';
  availableOnOccasion: Maybe<Array<Maybe<SessionOccasion>>>;
  composedImages: Maybe<Scalars['String']['output']>;
  config: Maybe<Scalars['String']['output']>;
  configurationImages: Maybe<Scalars['String']['output']>;
  deliveryTime: Maybe<Scalars['Int']['output']>;
  description: Maybe<Array<Maybe<CustomLabel>>>;
  hasWizard: Maybe<Scalars['Boolean']['output']>;
  imagesRequired: Maybe<Scalars['Boolean']['output']>;
  name: Maybe<Scalars['String']['output']>;
  organizationId: Maybe<Scalars['ID']['output']>;
  price: Maybe<Array<Maybe<PriceConfig>>>;
  productId: Maybe<Scalars['ID']['output']>;
  requiredImages: Maybe<NumberRange>;
  showDeliveryTime: Maybe<Scalars['Boolean']['output']>;
  sortOrder: Maybe<Scalars['Int']['output']>;
  status: Maybe<Scalars['Boolean']['output']>;
  type: Maybe<ProductType>;
};

export enum ProductMode {
  AllImagesFromPackage = 'AllImagesFromPackage',
  AnyImages = 'AnyImages',
  AnyImagesFromPackage = 'AnyImagesFromPackage',
}

export type ProductPackage = {
  __typename?: 'ProductPackage';
  allowMultiple: Maybe<Scalars['Boolean']['output']>;
  icon: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  price: Maybe<Array<Maybe<PriceConfig>>>;
  printAndFileConfig: Maybe<Array<Maybe<PrintAndFileConfig>>>;
  productConfig: Maybe<Array<Maybe<ProductConfig>>>;
  productPackageId: Maybe<Scalars['ID']['output']>;
};

export type ProductTaxConfig = {
  __typename?: 'ProductTaxConfig';
  label: Maybe<Scalars['String']['output']>;
  vatRate: Maybe<Scalars['Int']['output']>;
};

export type ProductTaxConfigInput = {
  label?: InputMaybe<Scalars['String']['input']>;
  vatRate?: InputMaybe<Scalars['Int']['input']>;
};

export type ProductToProductRelation = {
  __typename?: 'ProductToProductRelation';
  id: Maybe<Scalars['String']['output']>;
  labId: Maybe<Scalars['String']['output']>;
  parentId: Maybe<Scalars['String']['output']>;
  productId: Maybe<Scalars['String']['output']>;
  type: Maybe<ProductToProductRelationType>;
  value: Maybe<Scalars['String']['output']>;
};

export enum ProductToProductRelationType {
  Attribute = 'Attribute',
  Lab = 'Lab',
  Option = 'Option',
  Product = 'Product',
}

export enum ProductType {
  Album = 'Album',
  AlbumSet2plusOne = 'AlbumSet2plusOne',
  AlbumSetTriple = 'AlbumSetTriple',
  AlbumWithAcrylicPicture = 'AlbumWithAcrylicPicture',
  Book = 'Book',
  Calendar = 'Calendar',
  Canvas = 'Canvas',
  EconomicTwoPageTablo = 'EconomicTwoPageTablo',
  FatPrint = 'FatPrint',
  Frame = 'Frame',
  IdentityPhoto = 'IdentityPhoto',
  MagnetSticker = 'MagnetSticker',
  Mug = 'Mug',
  Other = 'Other',
  Prints = 'Prints',
  Tablo = 'Tablo',
  Tambour = 'Tambour',
  Triplex = 'Triplex',
  Wallart = 'Wallart',
  ZalamoCalendar = 'ZalamoCalendar',
  ZalamoEconomicTwoPageTablo = 'ZalamoEconomicTwoPageTablo',
  ZalamoMagnet = 'ZalamoMagnet',
  ZalamoPremiumTwoPageTablo = 'ZalamoPremiumTwoPageTablo',
}

export type ProtectionWatermarkConfig = {
  __typename?: 'ProtectionWatermarkConfig';
  aiLevel: Maybe<Scalars['String']['output']>;
  customConfig: Maybe<SoldFilesUniversalWatermarkConfig>;
  fileName: Maybe<Scalars['ID']['output']>;
  linesOpacity: Maybe<Scalars['Float']['output']>;
  mode: ProtectionWatermarkMode;
  showLines: Maybe<Scalars['Boolean']['output']>;
  source: Maybe<ProtectionWatermarkSource>;
  text: Maybe<Array<Maybe<CustomLabel>>>;
  textOpacity: Maybe<Scalars['Float']['output']>;
};

export type ProtectionWatermarkConfigInput = {
  aiLevel?: InputMaybe<Scalars['String']['input']>;
  customConfig?: InputMaybe<SoldFilesUniversalWatermarkConfigInput>;
  fileName: Scalars['ID']['input'];
  linesOpacity: Scalars['Float']['input'];
  mode: ProtectionWatermarkMode;
  showLines: Scalars['Boolean']['input'];
  source: ProtectionWatermarkSource;
  text: Array<InputMaybe<CustomLabelInput>>;
  textOpacity: Scalars['Float']['input'];
};

export enum ProtectionWatermarkMode {
  Custom = 'Custom',
  Multi = 'Multi',
  Single = 'Single',
}

export enum ProtectionWatermarkSource {
  AntiAi = 'AntiAi',
  Image = 'Image',
  Text = 'Text',
}

export type PublicSessionAuthDetails = {
  __typename?: 'PublicSessionAuthDetails';
  PublicSessionAuthDetailsId: Maybe<Scalars['ID']['output']>;
  authMode: Maybe<PublicSessionAuthMode>;
  deadline: Maybe<Scalars['Int']['output']>;
  horizontalLogo: Maybe<Scalars['ID']['output']>;
  inAppOnly: Maybe<Scalars['Boolean']['output']>;
  isActive: Maybe<Scalars['Boolean']['output']>;
  name: Maybe<Array<Maybe<CustomLabel>>>;
  organizationId: Maybe<Scalars['ID']['output']>;
  personAccessRequired: Scalars['Boolean']['output'];
  squareLogo: Maybe<Scalars['ID']['output']>;
  token: Maybe<Scalars['String']['output']>;
};

export enum PublicSessionAuthMode {
  NoAuth = 'NoAuth',
  Password = 'Password',
}

export enum PublicSessionContext {
  CompanyEvent = 'CompanyEvent',
  CompetitionBasketball = 'CompetitionBasketball',
  CompetitionBikeRiding = 'CompetitionBikeRiding',
  CompetitionCarRace = 'CompetitionCarRace',
  CompetitionDance = 'CompetitionDance',
  CompetitionFootball = 'CompetitionFootball',
  CompetitionHorseRiding = 'CompetitionHorseRiding',
  CompetitionMotoBike = 'CompetitionMotoBike',
  CompetitionRunning = 'CompetitionRunning',
  KindergartenSession = 'KindergartenSession',
  None = 'None',
  Prom = 'Prom',
  ReligionEventBaptism = 'ReligionEventBaptism',
  ReligionEventFirstCommunion = 'ReligionEventFirstCommunion',
  ReligionEventWedding = 'ReligionEventWedding',
  SchoolSession = 'SchoolSession',
  ShowCats = 'ShowCats',
  ShowDogs = 'ShowDogs',
  ShowHorses = 'ShowHorses',
}

export type PublicSessionForDisplay = {
  __typename?: 'PublicSessionForDisplay';
  addEveryFileToBasketIfNotAlreadyBought: Maybe<Scalars['Boolean']['output']>;
  addPriceToEveryFileInProduct: Maybe<Scalars['Boolean']['output']>;
  addPrintFileToBasketIfNotAlreadyBought: Maybe<Scalars['Boolean']['output']>;
  addToFirstPrintPrice: Maybe<Scalars['Boolean']['output']>;
  authMode: Maybe<PublicSessionAuthMode>;
  autoSellConfig: Maybe<AutoSellConfig>;
  autoSellEnabled: Maybe<Scalars['Boolean']['output']>;
  availableProducts: Maybe<Array<Maybe<ProductForDisplay>>>;
  calendarPrices: Maybe<Array<Maybe<CalendarForDisplay>>>;
  clientPermissionsConfig: Maybe<Scalars['String']['output']>;
  context: Maybe<PublicSessionContext>;
  cover: Maybe<CoverSetup>;
  created: Maybe<Scalars['Int']['output']>;
  customDigitalFileName: Maybe<Array<Maybe<CustomLabel>>>;
  deliveryMethods: Maybe<Array<Maybe<DeliveryMethodForDisplay>>>;
  digitalOrderForcePhone: Maybe<Scalars['Boolean']['output']>;
  disableImageZoom: Maybe<Scalars['Boolean']['output']>;
  doNotAddPriceOfFirstPrint: Maybe<Scalars['Boolean']['output']>;
  eSkarbonka: Maybe<PublicSessionOrganizationEskarbonkaProgress>;
  enableFreeThumb: Maybe<Scalars['Boolean']['output']>;
  enableKeywordSearch: Maybe<Scalars['Boolean']['output']>;
  enableMinimalOrderValue: Maybe<Scalars['Boolean']['output']>;
  excludedProducts: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  filePricing: Maybe<Array<Maybe<FilePricing>>>;
  frame: Maybe<Product>;
  freeDownloadAllAvailable: Maybe<Scalars['Boolean']['output']>;
  freeDownloadAvailable: Maybe<Scalars['Boolean']['output']>;
  freePackageId: Maybe<Scalars['ID']['output']>;
  freeThumbSize: Maybe<Scalars['Int']['output']>;
  groupImagesByPeople: Maybe<Scalars['Boolean']['output']>;
  groupImagesByPeopleType: Maybe<GroupImagesByPeopleTypeForDisplay>;
  groups: Maybe<Array<Maybe<PublicSessionGroupForDisplay>>>;
  horizontalLogo: Maybe<Scalars['ID']['output']>;
  invoicingEnabled: Maybe<Scalars['Boolean']['output']>;
  isActive: Maybe<Scalars['Boolean']['output']>;
  lookBookConfig: Maybe<SessionLookBookConfigForDisplay>;
  lookBookEnabled: Maybe<Scalars['Boolean']['output']>;
  magnetPrices: Maybe<Array<Maybe<MagnetForDisplay>>>;
  messages: Maybe<Array<Maybe<PublicSessionMessage>>>;
  minimalOrderValue: Maybe<Array<Maybe<PriceConfig>>>;
  name: Maybe<Array<Maybe<CustomLabel>>>;
  organizationId: Maybe<Scalars['ID']['output']>;
  ownPrintsPricing: Maybe<PrintsPricingListForDisplay>;
  packages: Maybe<Array<Maybe<ProductPackage>>>;
  people: Maybe<Array<Maybe<PersonForPublicSession>>>;
  picturesWithPeople: Maybe<Array<Maybe<PhotoWithPeople>>>;
  priceToAddToEveryFileInProduct: Maybe<Array<Maybe<PriceConfig>>>;
  priceToAddToFirstPrint: Maybe<Array<Maybe<PriceConfig>>>;
  printOwnPhotosEnabled: Maybe<Scalars['Boolean']['output']>;
  printsPricing: Maybe<PrintsPricingListForDisplay>;
  productsSort: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  promoPrintFlyerId: Maybe<Scalars['ID']['output']>;
  publicSessionId: Maybe<Scalars['String']['output']>;
  retouchLevels: Maybe<Array<Maybe<RetouchLevel>>>;
  retouchLevelsEnabled: Maybe<Scalars['Boolean']['output']>;
  sellCalendar: Maybe<Scalars['Boolean']['output']>;
  sellFiles: Maybe<Scalars['Boolean']['output']>;
  sellMagnet: Maybe<Scalars['Boolean']['output']>;
  sellPackages: Maybe<Scalars['Boolean']['output']>;
  sellPrints: Maybe<Scalars['Boolean']['output']>;
  sellProducts: Maybe<Scalars['Boolean']['output']>;
  sellTablo: Maybe<Scalars['Boolean']['output']>;
  showFileNames: Maybe<Scalars['Boolean']['output']>;
  skipAddToEveryFileInProductIfFileBought: Maybe<Scalars['Boolean']['output']>;
  skipAddToFirstPrintIfFileBought: Maybe<Scalars['Boolean']['output']>;
  squareLogo: Maybe<Scalars['ID']['output']>;
  status: Maybe<Scalars['Int']['output']>;
  tabloList: Maybe<Array<Maybe<TabloForDisplay>>>;
  tosId: Maybe<Scalars['ID']['output']>;
  useCustomDigitalFileName: Maybe<Scalars['Boolean']['output']>;
  useFilePricingToCalculatePriceToAddToEveryFileInPrint: Maybe<
    Scalars['Boolean']['output']
  >;
  useFilePricingToCalculatePriceToAddToEveryFileInProduct: Maybe<
    Scalars['Boolean']['output']
  >;
  usePromoCodes: Maybe<Scalars['Boolean']['output']>;
  visualPersonalization: Maybe<Scalars['String']['output']>;
};

export type PublicSessionGroupForDisplay = {
  __typename?: 'PublicSessionGroupForDisplay';
  addEveryFileToBasketIfNotAlreadyBought: Maybe<Scalars['Boolean']['output']>;
  addPriceToEveryFileInProduct: Maybe<Scalars['Boolean']['output']>;
  addPrintFileToBasketIfNotAlreadyBought: Maybe<Scalars['Boolean']['output']>;
  addToFirstPrintPrice: Maybe<Scalars['Boolean']['output']>;
  customFilesPricing: Maybe<Scalars['Boolean']['output']>;
  customPrintsPricing: Maybe<Scalars['Boolean']['output']>;
  customProductsConfig: Maybe<Scalars['Boolean']['output']>;
  disableLookBook: Maybe<Scalars['Boolean']['output']>;
  disableZalamoPrint: Maybe<Scalars['Boolean']['output']>;
  excludedProducts: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  filePricing: Maybe<Array<Maybe<FilePricing>>>;
  identityPhotoPaperId: Maybe<Scalars['ID']['output']>;
  identityPhotoPassDigital: Maybe<Scalars['Boolean']['output']>;
  images: Maybe<Array<Maybe<ImageForDisplay>>>;
  individualSellSettings: Maybe<Scalars['Boolean']['output']>;
  isIdentityPhotoOnly: Maybe<Scalars['Boolean']['output']>;
  name: Maybe<Array<Maybe<CustomLabel>>>;
  order: Maybe<Scalars['Int']['output']>;
  photoGroupId: Maybe<Scalars['String']['output']>;
  priceToAddToEveryFileInProduct: Maybe<Array<Maybe<PriceConfig>>>;
  priceToAddToFirstPrint: Maybe<Array<Maybe<PriceConfig>>>;
  printsPricing: Maybe<PrintsPricingListForDisplay>;
  productsSort: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  publicSessionGroupId: Maybe<Scalars['String']['output']>;
  publicSessionId: Maybe<Scalars['String']['output']>;
  sellFiles: Maybe<Scalars['Boolean']['output']>;
  sellPrints: Maybe<Scalars['Boolean']['output']>;
  sellProducts: Maybe<Scalars['Boolean']['output']>;
  skipAddToEveryFileInProductIfFileBought: Maybe<Scalars['Boolean']['output']>;
  skipAddToFirstPrintIfFileBought: Maybe<Scalars['Boolean']['output']>;
  status: Maybe<Scalars['Int']['output']>;
  useFilePricingToCalculatePriceToAddToEveryFileInPrint: Maybe<
    Scalars['Boolean']['output']
  >;
  useFilePricingToCalculatePriceToAddToEveryFileInProduct: Maybe<
    Scalars['Boolean']['output']
  >;
};

export type PublicSessionMessage = {
  __typename?: 'PublicSessionMessage';
  context: Maybe<PublicSessionMessageContext>;
  message: Maybe<Array<Maybe<CustomLabel>>>;
};

export enum PublicSessionMessageContext {
  Order = 'Order',
  Welcome = 'Welcome',
}

export type PublicSessionMessageInput = {
  context: PublicSessionMessageContext;
  message: Array<InputMaybe<CustomLabelInput>>;
};

export type PublicSessionOrganizationEskarbonkaProgress = {
  __typename?: 'PublicSessionOrganizationEskarbonkaProgress';
  currentAmount: Maybe<Scalars['Float']['output']>;
  enabled: Maybe<Scalars['Boolean']['output']>;
  limitAmount: Maybe<Scalars['Float']['output']>;
  percentage: Maybe<Scalars['Float']['output']>;
  publicLinkHash: Maybe<Scalars['ID']['output']>;
  publicSessionOrganizationId: Maybe<Scalars['ID']['output']>;
};

export type PublicSessionOrganizationEskarbonkaPublicView = {
  __typename?: 'PublicSessionOrganizationEskarbonkaPublicView';
  currentAmount: Maybe<Scalars['Float']['output']>;
  enabled: Maybe<Scalars['Boolean']['output']>;
  limitAmount: Maybe<Scalars['Float']['output']>;
  name: Maybe<Scalars['String']['output']>;
  percentage: Maybe<Scalars['Float']['output']>;
  publicSessionOrganizationId: Maybe<Scalars['ID']['output']>;
};

export type Query = {
  __typename?: 'Query';
  availableWatermarkFiles: Maybe<Array<Maybe<FileWatermark>>>;
  blackFridayStatus: Maybe<BlackFridayStatus>;
  dataProcessingAgreementDraft: Maybe<DataProcessingAgreementDraft>;
  dataProcessingAgreementTosPreview: Maybe<DataProcessingAgreementTosPreview>;
  getMe: Maybe<PhotographerAccount>;
  getMineCostInvoicesCount: Maybe<Scalars['Int']['output']>;
  getMineCostInvoicesUrl: Maybe<Scalars['String']['output']>;
  getMineIncomeInvoicesCount: Maybe<Scalars['Int']['output']>;
  getMineIncomeInvoicesUrl: Maybe<Scalars['String']['output']>;
  getMineIncomeOrganizationInvoices: Maybe<
    Array<Maybe<OrganizationInvoiceSummary>>
  >;
  getOrganizationKsefConfig: Maybe<OrganizationKsefConfig>;
  getSoldWatermarkConfig: Maybe<SoldFilesWatermarkConfig>;
  getTags: Maybe<TagsList>;
  getZalamoPayAvailableDates: Maybe<Array<Maybe<ZalamoPayAvailableDate>>>;
  getZalamoPayAvailableDatesIncoming: Maybe<
    Array<Maybe<ZalamoPayAvailableDate>>
  >;
  getZalamoPayIncomingInvoiceItems: Maybe<Array<Maybe<ZalamoPayInvoiceItem>>>;
  getZalamoPayInvoiceItems: Maybe<Array<Maybe<ZalamoPayInvoiceItem>>>;
  getZalamoPayInvoiceItemsForReport: Maybe<
    Array<Maybe<ZalamoPayInvoiceItemForReport>>
  >;
  hasAvailableCredits: Maybe<Scalars['Boolean']['output']>;
  me: Maybe<PhotographerAccount>;
  mineAccountDetails: Maybe<PhotographerAccountDetails>;
  mineAccountDevices: Array<PhotographerAccountDevice>;
  mineDataProcessingAgreement: Maybe<DataProcessingAgreement>;
  mock: Maybe<Scalars['String']['output']>;
  photoDetails: Maybe<Array<Maybe<Photo>>>;
  sampleSupplierOrdersConfig: Maybe<SupplierOrdersConfig>;
  supplierProductsForPricing: Maybe<Array<Maybe<Product>>>;
  validateNiceUrl: Maybe<NiceUrlValidationStatus>;
};

export type QueryAvailableWatermarkFilesArgs = {
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryDataProcessingAgreementDraftArgs = {
  organizationId: Scalars['ID']['input'];
};

export type QueryGetMineCostInvoicesCountArgs = {
  month: Scalars['Int']['input'];
  organizationId: Scalars['ID']['input'];
  year: Scalars['Int']['input'];
};

export type QueryGetMineCostInvoicesUrlArgs = {
  month: Scalars['Int']['input'];
  organizationId: Scalars['ID']['input'];
  year: Scalars['Int']['input'];
};

export type QueryGetMineIncomeInvoicesCountArgs = {
  month: Scalars['Int']['input'];
  organizationId: Scalars['ID']['input'];
  year: Scalars['Int']['input'];
};

export type QueryGetMineIncomeInvoicesUrlArgs = {
  month: Scalars['Int']['input'];
  organizationId: Scalars['ID']['input'];
  year: Scalars['Int']['input'];
};

export type QueryGetMineIncomeOrganizationInvoicesArgs = {
  month: Scalars['Int']['input'];
  organizationId: Scalars['ID']['input'];
  year: Scalars['Int']['input'];
};

export type QueryGetOrganizationKsefConfigArgs = {
  environment?: InputMaybe<KsefEnvironment>;
  organizationId: Scalars['ID']['input'];
};

export type QueryGetSoldWatermarkConfigArgs = {
  photoId?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryGetTagsArgs = {
  context: ZalamoObject;
  organizationId: Scalars['ID']['input'];
};

export type QueryGetZalamoPayAvailableDatesArgs = {
  organizationId: Scalars['ID']['input'];
};

export type QueryGetZalamoPayAvailableDatesIncomingArgs = {
  organizationId: Scalars['ID']['input'];
};

export type QueryGetZalamoPayIncomingInvoiceItemsArgs = {
  month: Scalars['Int']['input'];
  organizationId: Scalars['ID']['input'];
  year: Scalars['Int']['input'];
};

export type QueryGetZalamoPayInvoiceItemsArgs = {
  month: Scalars['Int']['input'];
  organizationId: Scalars['ID']['input'];
  year: Scalars['Int']['input'];
};

export type QueryGetZalamoPayInvoiceItemsForReportArgs = {
  month: Scalars['Int']['input'];
  organizationId: Scalars['ID']['input'];
  year: Scalars['Int']['input'];
};

export type QueryHasAvailableCreditsArgs = {
  context: ZalamoObject;
  organizationId: Scalars['ID']['input'];
  type?: InputMaybe<CreditType>;
};

export type QueryMeArgs = {
  organizationId: Scalars['ID']['input'];
};

export type QueryMineAccountDetailsArgs = {
  organizationId: Scalars['ID']['input'];
};

export type QueryMineAccountDevicesArgs = {
  organizationId: Scalars['ID']['input'];
};

export type QueryMineDataProcessingAgreementArgs = {
  organizationId: Scalars['ID']['input'];
};

export type QueryPhotoDetailsArgs = {
  photos: Array<InputMaybe<Scalars['String']['input']>>;
};

export type QuerySampleSupplierOrdersConfigArgs = {
  organizationId: Scalars['ID']['input'];
};

export type QuerySupplierProductsForPricingArgs = {
  supplierId: Scalars['ID']['input'];
};

export type QueryValidateNiceUrlArgs = {
  contextId: Scalars['ID']['input'];
  currentContext?: InputMaybe<NiceUrlContainer>;
  niceUrl: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
};

export type QuickLink = {
  __typename?: 'QuickLink';
  label: Maybe<Array<Maybe<CustomLabel>>>;
  link: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  quickLinkId: Maybe<Scalars['ID']['output']>;
};

export type RetouchLevel = {
  __typename?: 'RetouchLevel';
  label: Maybe<Array<Maybe<CustomLabel>>>;
  price: Maybe<Array<Maybe<PriceConfig>>>;
  retouchLevelId: Maybe<Scalars['ID']['output']>;
};

export type RetouchLevelInput = {
  label: Array<InputMaybe<CustomLabelInput>>;
  price: Array<InputMaybe<PriceConfigInput>>;
  retouchLevelId: Scalars['ID']['input'];
};

export type SampleSupplierOrderConfig = {
  __typename?: 'SampleSupplierOrderConfig';
  hash: Maybe<Scalars['String']['output']>;
  orderNumber: Maybe<Scalars['Int']['output']>;
  productType: Maybe<ProductType>;
  status: Maybe<Scalars['Boolean']['output']>;
  supplierId: Scalars['ID']['output'];
};

export type SampleSupplierOrderInput = {
  file: Scalars['ID']['input'];
  fileHeight: Scalars['Int']['input'];
  fileWidth: Scalars['Int']['input'];
};

export type SamplesSupplierOrderInput = {
  clientEmail?: InputMaybe<Scalars['String']['input']>;
  clientFirstName?: InputMaybe<Scalars['String']['input']>;
  clientLastName?: InputMaybe<Scalars['String']['input']>;
  clientPhone?: InputMaybe<Scalars['String']['input']>;
  companyBuildingNumber?: InputMaybe<Scalars['String']['input']>;
  companyCity?: InputMaybe<Scalars['String']['input']>;
  companyFlatNumber?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  companyStreet?: InputMaybe<Scalars['String']['input']>;
  companyVatId?: InputMaybe<Scalars['String']['input']>;
  companyZipCode?: InputMaybe<Scalars['String']['input']>;
  deliveryAddressSameAsCompany?: InputMaybe<Scalars['Boolean']['input']>;
  deliveryBuildingNumber?: InputMaybe<Scalars['String']['input']>;
  deliveryCity?: InputMaybe<Scalars['String']['input']>;
  deliveryFlatNumber?: InputMaybe<Scalars['String']['input']>;
  deliveryStreet?: InputMaybe<Scalars['String']['input']>;
  deliveryType?: InputMaybe<Scalars['String']['input']>;
  deliveryZipCode?: InputMaybe<Scalars['String']['input']>;
  lockerAddress?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lockerId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  productType?: InputMaybe<ProductType>;
  supplierId?: InputMaybe<Scalars['ID']['input']>;
};

export type SaveDataProcessingAgreementDraftInput = {
  businessType?: InputMaybe<DataProcessingAgreementBusinessType>;
  dataAgreementDetails?: InputMaybe<DataAgreementDetailsInput>;
  representatives: Array<
    InputMaybe<DataProcessingAgreementRepresentativeInput>
  >;
};

export type SessionAlbumLookBookConfigForDisplay = {
  __typename?: 'SessionAlbumLookBookConfigForDisplay';
  commission: Maybe<Scalars['Int']['output']>;
  excludedMaterials: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  excludedSizes: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  labIds: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  rounding: Maybe<LookBookPriceRounding>;
};

export type SessionLookBookConfigForDisplay = {
  __typename?: 'SessionLookBookConfigForDisplay';
  addEveryFileToBasketIfNotAlreadyBought: Maybe<Scalars['Boolean']['output']>;
  addPriceToEveryFileInProduct: Maybe<Scalars['Boolean']['output']>;
  decorationPreConfig: Maybe<DecorationPreConfigForClient>;
  priceToAddToEveryFileInProduct: Maybe<Array<Maybe<PriceConfig>>>;
  printFramesConfig: Maybe<SessionPrintFramesLookBookConfigForDisplay>;
  sellAlbums: Maybe<Scalars['Boolean']['output']>;
  sellPrintFrames: Maybe<Scalars['Boolean']['output']>;
  sellTambour: Maybe<Scalars['Boolean']['output']>;
  sellTriplex: Maybe<Scalars['Boolean']['output']>;
  sellWallDecor: Maybe<Scalars['Boolean']['output']>;
  skipAddToEveryFileInProductIfFileBought: Maybe<Scalars['Boolean']['output']>;
  tambourConfig: Maybe<SessionWallDecorLookBookConfigForDisplay>;
  triplexConfig: Maybe<SessionTriplexLookBookConfigForDisplay>;
  useFilePricingToCalculatePriceToAddToEveryFileInProduct: Maybe<
    Scalars['Boolean']['output']
  >;
  wallDecorConfig: Maybe<SessionWallDecorLookBookConfigForDisplay>;
};

export enum SessionOccasion {
  Baphthism = 'Baphthism',
  Birthday = 'Birthday',
  FirstBirthday = 'FirstBirthday',
  FirstCommunion = 'FirstCommunion',
  Newborn = 'Newborn',
  Wedding = 'Wedding',
}

export type SessionPrintFrameConfig = {
  __typename?: 'SessionPrintFrameConfig';
  color: Maybe<Scalars['String']['output']>;
  format: Maybe<Scalars['String']['output']>;
  price: Maybe<Array<Maybe<PriceConfig>>>;
  sessionPrintFrameConfigId: Maybe<Scalars['ID']['output']>;
  shape: Maybe<Scalars['String']['output']>;
};

export type SessionPrintFramesLookBookConfigForDisplay = {
  __typename?: 'SessionPrintFramesLookBookConfigForDisplay';
  availableColors: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  limitColors: Maybe<Scalars['Boolean']['output']>;
  rounding: Maybe<LookBookPriceRounding>;
};

export type SessionTriplexLookBookConfigForDisplay = {
  __typename?: 'SessionTriplexLookBookConfigForDisplay';
  availableMaterials: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  labId: Maybe<Scalars['String']['output']>;
  limitMaterials: Maybe<Scalars['Boolean']['output']>;
  rounding: Maybe<LookBookPriceRounding>;
};

export type SessionWallDecorLookBookConfigForDisplay = {
  __typename?: 'SessionWallDecorLookBookConfigForDisplay';
  disablePersonalizationOnSinglePhoto: Maybe<Scalars['Boolean']['output']>;
  labId: Maybe<Scalars['String']['output']>;
  preConfig: Maybe<Scalars['String']['output']>;
  rounding: Maybe<LookBookPriceRounding>;
};

export type SoldFilesUniversalWatermarkConfig = {
  __typename?: 'SoldFilesUniversalWatermarkConfig';
  horizontal: Maybe<SoldFilesWatermarkConfig>;
  soldFilesUniversalWatermarkConfigId: Maybe<Scalars['ID']['output']>;
  vertical: Maybe<SoldFilesWatermarkConfig>;
};

export type SoldFilesUniversalWatermarkConfigInput = {
  horizontal: SoldFilesWatermarkConfigInput;
  soldFilesUniversalWatermarkConfigId?: InputMaybe<Scalars['ID']['input']>;
  vertical: SoldFilesWatermarkConfigInput;
};

export type SoldFilesWatermarkConfig = {
  __typename?: 'SoldFilesWatermarkConfig';
  alpha: Maybe<Scalars['Float']['output']>;
  config: Maybe<SoldFilesWatermarkConfigPosition>;
  file: Maybe<Scalars['String']['output']>;
  soldFilesWatermarkConfigId: Maybe<Scalars['ID']['output']>;
};

export type SoldFilesWatermarkConfigInput = {
  alpha: Scalars['Float']['input'];
  config: SoldFilesWatermarkConfigPositionInput;
  file: Scalars['String']['input'];
  soldFilesWatermarkConfigId: Scalars['ID']['input'];
};

export type SoldFilesWatermarkConfigPosition = {
  __typename?: 'SoldFilesWatermarkConfigPosition';
  left: Maybe<Scalars['Float']['output']>;
  soldFilesWatermarkConfigPositionId: Maybe<Scalars['ID']['output']>;
  top: Maybe<Scalars['Float']['output']>;
  width: Maybe<Scalars['Float']['output']>;
};

export type SoldFilesWatermarkConfigPositionInput = {
  left: Scalars['Float']['input'];
  soldFilesWatermarkConfigPositionId: Scalars['ID']['input'];
  top: Scalars['Float']['input'];
  width: Scalars['Float']['input'];
};

export type StartDataProcessingAgreementSigningInput = {
  businessType: DataProcessingAgreementBusinessType;
  dataAgreementDetails: DataAgreementDetailsInput;
  representatives: Array<
    InputMaybe<DataProcessingAgreementRepresentativeInput>
  >;
};

export type StepPricing = {
  __typename?: 'StepPricing';
  firstStep: Maybe<Scalars['Int']['output']>;
  isFirstStepFree: Maybe<Scalars['Boolean']['output']>;
  lastStepPrice: Maybe<Array<Maybe<PriceConfig>>>;
  mode: Maybe<StepPricingMode>;
  steps: Maybe<Array<Maybe<PriceStep>>>;
};

export type StepPricingInput = {
  firstStep: Scalars['Int']['input'];
  isFirstStepFree: Scalars['Boolean']['input'];
  lastStepPrice: Array<InputMaybe<PriceConfigInput>>;
  mode: StepPricingMode;
  steps: Array<InputMaybe<PriceStepInput>>;
};

export enum StepPricingMode {
  Bundles = 'Bundles',
  ForAll = 'ForAll',
  ForOverTreshold = 'ForOverTreshold',
  None = 'None',
}

export type SubdomainUpdateResult = {
  __typename?: 'SubdomainUpdateResult';
  organization: Maybe<Organization>;
  status: Maybe<Scalars['Boolean']['output']>;
};

export type Subscription = {
  __typename?: 'Subscription';
  deviceLoggedOut: DeviceLoggedOutEvent;
  mockSub: Maybe<Scalars['ID']['output']>;
};

export type SupplierOrdersConfig = {
  __typename?: 'SupplierOrdersConfig';
  file: Maybe<Scalars['ID']['output']>;
  suppliers: Maybe<Array<Maybe<SampleSupplierOrderConfig>>>;
};

export type TabloForDisplay = {
  __typename?: 'TabloForDisplay';
  price: Maybe<Array<Maybe<PriceConfig>>>;
  size: Maybe<TabloSize>;
  tabloForDisplayId: Maybe<Scalars['ID']['output']>;
};

export enum TabloSize {
  S15x20 = 's15x20',
  S20x15 = 's20x15',
  S20x30 = 's20x30',
}

export type TagsList = {
  __typename?: 'TagsList';
  tags: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type TriplexRenderPreviewConfig = {
  __typename?: 'TriplexRenderPreviewConfig';
  accessToken: Maybe<Scalars['ID']['output']>;
  fileName: Maybe<Scalars['ID']['output']>;
  images: Maybe<Array<Maybe<WallDecorRenderPieceConfig>>>;
  triplexRenderPreviewConfigId: Maybe<Scalars['ID']['output']>;
  value: Maybe<Scalars['String']['output']>;
};

export type TriplexRenderPreviewConfigInput = {
  fileName?: InputMaybe<Scalars['ID']['input']>;
  images?: InputMaybe<Array<InputMaybe<WallDecorRenderPieceConfigInput>>>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateFilesConfig = {
  count: Scalars['Int']['input'];
  isFull: Scalars['Boolean']['input'];
  size: Scalars['Int']['input'];
};

export type UpdatePrintAndFileConfig = {
  filesConfig?: InputMaybe<Array<InputMaybe<UpdateFilesConfig>>>;
  forcedImage?: InputMaybe<ForcedImageConfigUpdate>;
  groups: Array<InputMaybe<Scalars['String']['input']>>;
  mode?: InputMaybe<FilesAndPrintsPackageType>;
  printAndFileConfigId?: InputMaybe<Scalars['ID']['input']>;
  printsCount?: InputMaybe<Array<InputMaybe<UpdatePrintsCount>>>;
};

export type UpdatePrintsCount = {
  count: Scalars['Int']['input'];
  printFormatId: Scalars['String']['input'];
  printPaperId: Scalars['String']['input'];
};

export type UpdateProductConfig = {
  config: Scalars['String']['input'];
  customName?: InputMaybe<Array<InputMaybe<CustomLabelInput>>>;
  icon?: InputMaybe<Scalars['String']['input']>;
  mode?: InputMaybe<ProductMode>;
  productId: Scalars['String']['input'];
  productInPackageId: Scalars['String']['input'];
  qty: Scalars['Int']['input'];
};

export type UpdateProductPackage = {
  allowMultiple?: InputMaybe<Scalars['Boolean']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  price: Array<InputMaybe<PriceConfigInput>>;
  printAndFileConfig: Array<InputMaybe<UpdatePrintAndFileConfig>>;
  productConfig: Array<InputMaybe<UpdateProductConfig>>;
  productPackageId?: InputMaybe<Scalars['ID']['input']>;
};

export enum UserTest {
  AntiAiWatermark = 'AntiAiWatermark',
  AutoSell = 'AutoSell',
  BigUpgrades = 'BigUpgrades',
  BookingLite = 'BookingLite',
  CampaignTrackedShootingCreation = 'CampaignTrackedShootingCreation',
  CountryPricePicker = 'CountryPricePicker',
  DidShop = 'DidShop',
  EmbedStore = 'EmbedStore',
  EmpikFoto = 'EmpikFoto',
  FilePricingAsSourceForPriceToAddToEveryFileInProduct = 'FilePricingAsSourceForPriceToAddToEveryFileInProduct',
  IdentityPhotoSell = 'IdentityPhotoSell',
  KrukBook = 'KrukBook',
  Notifications = 'Notifications',
  P1 = 'P1',
  P2 = 'P2',
  P3 = 'P3',
  PermissionsCollection = 'PermissionsCollection',
  PrintOwnPhotos = 'PrintOwnPhotos',
  PrivateSession = 'PrivateSession',
  PrivateSessionLookBook = 'PrivateSessionLookBook',
  PublicSessionSignupCampaigns = 'PublicSessionSignupCampaigns',
  PublicSessionTemplates = 'PublicSessionTemplates',
  ScreenAppProtection = 'ScreenAppProtection',
  ScreenAppProtectionn = 'ScreenAppProtectionn',
  SellTriplex = 'SellTriplex',
  SellZalamoFrames = 'SellZalamoFrames',
  SnapPremiumPackage = 'SnapPremiumPackage',
  TabloDesigner = 'TabloDesigner',
  TestPremiumLab = 'TestPremiumLab',
  VisualGuides = 'VisualGuides',
  ZalamoPrintExperience = 'ZalamoPrintExperience',
  Csv = 'csv',
}

export enum VatType {
  Applied = 'Applied',
  Exempt = 'Exempt',
}

export type WallDecorPieceCrop = {
  __typename?: 'WallDecorPieceCrop';
  h: Maybe<Scalars['Float']['output']>;
  w: Maybe<Scalars['Float']['output']>;
  x: Maybe<Scalars['Float']['output']>;
  y: Maybe<Scalars['Float']['output']>;
};

export type WallDecorPieceCropInput = {
  h: Scalars['Float']['input'];
  w: Scalars['Float']['input'];
  x: Scalars['Float']['input'];
  y: Scalars['Float']['input'];
};

export type WallDecorRenderPieceConfig = {
  __typename?: 'WallDecorRenderPieceConfig';
  crop: Maybe<WallDecorPieceCrop>;
  isFlip: Maybe<Scalars['Boolean']['output']>;
  photoGroupId: Maybe<Scalars['ID']['output']>;
  photoId: Maybe<Scalars['ID']['output']>;
  wallDecorPieceId: Maybe<Scalars['ID']['output']>;
};

export type WallDecorRenderPieceConfigInput = {
  crop: WallDecorPieceCropInput;
  isFlip: Scalars['Boolean']['input'];
  photoGroupId: Scalars['ID']['input'];
  photoId: Scalars['ID']['input'];
  wallDecorPieceId: Scalars['ID']['input'];
};

export type WallDecorRenderPreviewConfig = {
  __typename?: 'WallDecorRenderPreviewConfig';
  accessToken: Maybe<Scalars['ID']['output']>;
  color: Maybe<Scalars['String']['output']>;
  fileName: Maybe<Scalars['ID']['output']>;
  images: Maybe<Array<Maybe<WallDecorRenderPieceConfig>>>;
  wallDecorRenderPreviewConfigId: Maybe<Scalars['ID']['output']>;
  wallDecorSceneId: Maybe<Scalars['ID']['output']>;
};

export type WallDecorRenderPreviewConfigInput = {
  accessToken?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  fileName?: InputMaybe<Scalars['ID']['input']>;
  images?: InputMaybe<Array<InputMaybe<WallDecorRenderPieceConfigInput>>>;
  wallDecorSceneId?: InputMaybe<Scalars['ID']['input']>;
};

export enum ZalamoObject {
  BookingPortfolio = 'BookingPortfolio',
  CompetitionEntry = 'CompetitionEntry',
  Conversation = 'Conversation',
  DesignerAsset = 'DesignerAsset',
  DigitalOrder = 'DigitalOrder',
  LegacyPrivateSessionFileOrder = 'LegacyPrivateSessionFileOrder',
  LookBookOrder = 'LookBookOrder',
  OldZalamoClient = 'OldZalamoClient',
  Order = 'Order',
  Organization = 'Organization',
  OrganizationClient = 'OrganizationClient',
  OrganizationPromoPrintFlyers = 'OrganizationPromoPrintFlyers',
  PrintsOrder = 'PrintsOrder',
  PrivateSession = 'PrivateSession',
  PrivateSessionGroup = 'PrivateSessionGroup',
  Product = 'Product',
  ProductInOrder = 'ProductInOrder',
  PublicSession = 'PublicSession',
  PublicSessionChildren = 'PublicSessionChildren',
  PublicSessionGroup = 'PublicSessionGroup',
  PublicSessionOrganization = 'PublicSessionOrganization',
  PublicSessionOrganizationGroup = 'PublicSessionOrganizationGroup',
  SupportThread = 'SupportThread',
  ZalamoPrintOrder = 'ZalamoPrintOrder',
}

export type ZalamoPayAvailableDate = {
  __typename?: 'ZalamoPayAvailableDate';
  month: Scalars['Int']['output'];
  year: Scalars['Int']['output'];
};

export type ZalamoPayInvoiceItem = {
  __typename?: 'ZalamoPayInvoiceItem';
  amount: Scalars['Float']['output'];
  context: Maybe<InvoiceToBeCreatedContext>;
  contextId: Maybe<Scalars['String']['output']>;
  created: Scalars['Float']['output'];
  currency: Maybe<Scalars['String']['output']>;
  forAggregated: Maybe<Scalars['Boolean']['output']>;
  invoiceDetails: Maybe<InvoiceDetails>;
  invoiceId: Maybe<Scalars['ID']['output']>;
  legacyPaymentId: Maybe<Scalars['String']['output']>;
  organizationId: Maybe<Scalars['ID']['output']>;
  ownerOrganizationId: Maybe<Scalars['ID']['output']>;
  p24PaymentId: Maybe<Scalars['ID']['output']>;
  zalamoPayPaymentId: Maybe<Scalars['String']['output']>;
};

export type ZalamoPayInvoiceItemForReport = {
  __typename?: 'ZalamoPayInvoiceItemForReport';
  amount: Maybe<Scalars['Float']['output']>;
  currency: Maybe<Scalars['String']['output']>;
  email: Maybe<Scalars['String']['output']>;
  firstName: Maybe<Scalars['String']['output']>;
  lastName: Maybe<Scalars['String']['output']>;
  number: Maybe<Scalars['Int']['output']>;
  paidDate: Maybe<Scalars['Int']['output']>;
};

export type ZalamoPayP24RegisterInput = {
  addressCity: Scalars['String']['input'];
  addressPostCode: Scalars['String']['input'];
  addressStreet: Scalars['String']['input'];
  bankAccount: Scalars['String']['input'];
  businessType: Scalars['String']['input'];
  contactPersonName: Scalars['String']['input'];
  contactPersonPhoneNumber: Scalars['String']['input'];
  correspondenceAddressCity: Scalars['String']['input'];
  correspondenceAddressPostCode: Scalars['String']['input'];
  correspondenceAddressStreet: Scalars['String']['input'];
  krs: Scalars['String']['input'];
  name: Scalars['String']['input'];
  nip: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  regon: Scalars['String']['input'];
  representatives: Array<InputMaybe<ZalamoPayP24RepresentativeInput>>;
};

export type ZalamoPayP24RepresentativeInput = {
  name: Scalars['String']['input'];
  pesel: Scalars['String']['input'];
};

export type ZalamoPayRegisterResponse = {
  __typename?: 'ZalamoPayRegisterResponse';
  link: Maybe<Scalars['String']['output']>;
  status: Maybe<Scalars['Boolean']['output']>;
};

export enum ZalamoPayTransferReason {
  FileTransfer = 'FileTransfer',
  MarketingServices = 'MarketingServices',
  OwnMoney = 'OwnMoney',
  PaymentCommission = 'PaymentCommission',
  PrintServices = 'PrintServices',
  ZalamoCredits = 'ZalamoCredits',
}

export type ZalamoPrintSessionConfig = {
  __typename?: 'ZalamoPrintSessionConfig';
  addEveryFileToBasketIfNotAlreadyBought: Maybe<Scalars['Boolean']['output']>;
  addPriceToEveryFileInProduct: Maybe<Scalars['Boolean']['output']>;
  calendarPrice: Maybe<Array<Maybe<ZalamoPrintSessionTabloPricingConfig>>>;
  enabledTabloSizes: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  magnetPrice: Maybe<Array<Maybe<ZalamoPrintSessionTabloPricingConfig>>>;
  priceToAddToEveryFileInProduct: Maybe<Array<Maybe<PriceConfig>>>;
  sellCalendar: Maybe<Scalars['Boolean']['output']>;
  sellMagnet: Maybe<Scalars['Boolean']['output']>;
  sellTablo: Maybe<Scalars['Boolean']['output']>;
  skipAddToEveryFileInProductIfFileBought: Maybe<Scalars['Boolean']['output']>;
  tabloPricing: Maybe<Array<Maybe<ZalamoPrintSessionTabloPricingConfig>>>;
  useFilePricingToCalculatePriceToAddToEveryFileInProduct: Maybe<
    Scalars['Boolean']['output']
  >;
  zalamoPrintSessionConfigId: Maybe<Scalars['ID']['output']>;
};

export type ZalamoPrintSessionConfigInput = {
  addEveryFileToBasketIfNotAlreadyBought?: InputMaybe<
    Scalars['Boolean']['input']
  >;
  addPriceToEveryFileInProduct?: InputMaybe<Scalars['Boolean']['input']>;
  calendarPrice?: InputMaybe<
    Array<InputMaybe<ZalamoPrintSessionTabloPricingConfigInput>>
  >;
  enabledTabloSizes?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  magnetPrice?: InputMaybe<
    Array<InputMaybe<ZalamoPrintSessionTabloPricingConfigInput>>
  >;
  priceToAddToEveryFileInProduct?: InputMaybe<
    Array<InputMaybe<PriceConfigInput>>
  >;
  sellCalendar?: InputMaybe<Scalars['Boolean']['input']>;
  sellMagnet?: InputMaybe<Scalars['Boolean']['input']>;
  sellTablo?: InputMaybe<Scalars['Boolean']['input']>;
  skipAddToEveryFileInProductIfFileBought?: InputMaybe<
    Scalars['Boolean']['input']
  >;
  tabloPricing?: InputMaybe<
    Array<InputMaybe<ZalamoPrintSessionTabloPricingConfigInput>>
  >;
  useFilePricingToCalculatePriceToAddToEveryFileInProduct?: InputMaybe<
    Scalars['Boolean']['input']
  >;
};

export type ZalamoPrintSessionTabloConfig = {
  __typename?: 'ZalamoPrintSessionTabloConfig';
  formatLabel: Maybe<Scalars['String']['output']>;
  price: Maybe<Array<Maybe<PriceConfig>>>;
  tabloIndex: Maybe<Scalars['Int']['output']>;
  zalamoPrintSizeId: Maybe<Scalars['ID']['output']>;
};

export type ZalamoPrintSessionTabloPricingConfig = {
  __typename?: 'ZalamoPrintSessionTabloPricingConfig';
  price: Maybe<Array<Maybe<PriceConfig>>>;
  zalamoPrintSizeId: Maybe<Scalars['ID']['output']>;
};

export type ZalamoPrintSessionTabloPricingConfigInput = {
  price?: InputMaybe<Array<InputMaybe<PriceConfigInput>>>;
  zalamoPrintSizeId?: InputMaybe<Scalars['ID']['input']>;
};
